import React, { useState } from "react";
import "./style.css";

const mockData = [
  {
    id: "1",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    counter: "MTR-2024-789456",
    spotId: 1,
    status: "available",
    progress: 0,
    consumption: 0,
    reading: 1245.6,
  },
  {
    id: "2",
    building: 'Офисный комплекс "Север"',
    serial: "EVSE-SER-2024-001",
    counter: "MTR-2024-789456",
    spotId: 2,
    status: "charging",
    progress: 65,
    consumption: 32.4,
    reading: 2156.8,
  },
];

const getStatusConfig = (status: string) => {
  const configs: Record<string, { label: string; color: string; bg: string; dot: string }> = {
    available: { label: "Свободно", color: "#2e7d32", bg: "#e8f5e9", dot: "#2e7d32" },
    charging: { label: "Заряжается", color: "#2e7d32", bg: "#e8f5e9", dot: "#2e7d32" },
    occupied: { label: "Занято", color: "#f59e0b", bg: "#fef3c7", dot: "#f59e0b" },
    completed: { label: "Заряжено", color: "#8b5cf6", bg: "#ede9fe", dot: "#8b5cf6" },
    error: { label: "Ошибка", color: "#c0392b", bg: "#fee2e2", dot: "#c0392b" },
    unavailable: { label: "Недоступно", color: "#888", bg: "#e8e8e8", dot: "#bbb" },
  };
  return configs[status] || configs.unavailable;
};

const DemoUsersV4 = () => {
  const [running, setRunning] = useState<Record<string, boolean>>({});

  const toggle = (id: string) => {
    setRunning((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="v4-wrapper">
      {/* Шапка */}
      <header className="v4-header">
        <div className="v4-user-badge">
          <div className="v4-avatar">А</div>
          <span className="v4-user-name">alexey@example.com</span>
        </div>
        <button className="v4-logout-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </header>

      {/* Карточки */}
      {mockData.map((item) => {
        const st = getStatusConfig(item.status);
        return (
          <div key={item.id} className="v4-card">
            {/* Шапка карточки */}
            <div className="v4-card-header">
              <h2 className="v4-station-title">{item.building}</h2>
              <div className="v4-station-address">
                <svg className="v4-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                ул. Ленина, 42
              </div>
            </div>

            {/* Тело карточки */}
            <div className="v4-card-body">
              {/* Серийные номера */}
              <div className="v4-serial-block">
                <div className="v4-serial-row">
                  <span className="v4-serial-label">Серийный №</span>
                  <span className="v4-serial-value">{item.serial}</span>
                </div>
                <div className="v4-serial-row">
                  <span className="v4-serial-label">Счётчик №</span>
                  <span className="v4-serial-value">{item.counter}</span>
                </div>
              </div>

              {/* Место + состояние */}
              <div className="v4-main-zone">
                <div className="v4-spot-zone">
                  <div className="v4-spot-icon" style={{ color: st.color }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="4" y="4" width="16" height="16" rx="2" />
                      <path d="M12 2v20" />
                      <path d="M2 12h20" />
                    </svg>
                  </div>
                  <div className="v4-spot-info">
                    <span className="v4-spot-number">{item.spotId}</span>
                    <span
                      className="v4-status-pill"
                      style={{ background: st.bg, color: st.color }}
                    >
                      <span
                        className="v4-status-dot"
                        style={{
                          background: st.dot,
                          animation: item.status === "unavailable" ? "none" : "v4-pulse 2.5s infinite",
                        }}
                      />
                      {st.label}
                    </span>
                  </div>
                </div>
              </div>

              {/* Метрики */}
              <div className="v4-metrics">
                <div className="v4-metric-block">
                  <div className="v4-metric-icon-box v4-current">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                    </svg>
                  </div>
                  <div className="v4-metric-data">
                    <div className="v4-metric-label">Текущий ток</div>
                    <div className="v4-metric-value">
                      {item.consumption}<span className="v4-metric-unit">А</span>
                    </div>
                  </div>
                </div>

                <div className="v4-metric-block">
                  <div className="v4-metric-icon-box v4-meter">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                    </svg>
                  </div>
                  <div className="v4-metric-data">
                    <div className="v4-metric-label">Показания счётчика</div>
                    <div className="v4-metric-value">
                      {item.reading}<span className="v4-metric-unit">кВт·ч</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DemoUsersV4;
